import { __awaiter, __generator } from "tslib";
import { getTaxSettings } from './getTaxSettings';
import { getPriceRangeSettings } from './getPriceRangeSettings';
import { getShippingSettings } from './getShippingSettings';
import { getCountryCodes } from './getCountryCodes';
import { SPECS } from '../../../constants';
export function createSettingsExports(_a) {
    var _this = this;
    var context = _a.context, origin = _a.origin;
    return {
        getSettings: function () { return __awaiter(_this, void 0, void 0, function () {
            var shouldFixGetClientConfigBlockingWidgets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldFixGetClientConfigBlockingWidgets = context.siteStore.experiments.enabled(SPECS.FixGetClientConfigBlockingWidgets);
                        if (!shouldFixGetClientConfigBlockingWidgets) return [3 /*break*/, 2];
                        return [4 /*yield*/, context.siteStore.loadClientConfig()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, {
                            price: getPriceRangeSettings(context.siteStore),
                            tax: getTaxSettings(context.siteStore),
                            shipping: getShippingSettings(context.siteStore),
                            storeId: context.siteStore.storeId,
                            instance: context.siteStore.instanceManager.getInstance(),
                            storeCurrency: context.siteStore.currency,
                            locale: context.siteStore.locale,
                        }];
                }
            });
        }); },
        getCountryCodes: getCountryCodes({ context: context, origin: origin }),
        getCurrentCurrency: function () { return __awaiter(_this, void 0, void 0, function () {
            var shouldFixGetClientConfigBlockingWidgets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldFixGetClientConfigBlockingWidgets = context.siteStore.experiments.enabled(SPECS.FixGetClientConfigBlockingWidgets);
                        if (!shouldFixGetClientConfigBlockingWidgets) return [3 /*break*/, 2];
                        return [4 /*yield*/, context.siteStore.loadClientConfig()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, context.siteStore.getCurrentCurrency()];
                }
            });
        }); },
    };
}
//# sourceMappingURL=wixcode.settings.js.map